﻿import { DamDocumentItem } from "@grindex-components/Sensus/DamDocumentItem.class";
import { $elementChild } from "@grindex-common/helpers/elements";
import { Loader } from "@grindex-components/Loader/loader.class";
let loader = null;

function init($view) {
	window.xylem = window.xylem || {};
	const $module = $view[0];
	const searchString = window.xylem.DamSearchString;
	const textNode = document.createTextNode(window.xylem.NoResultText);

	if (!searchString) {
		$module.appendChild(textNode);
		return;
	}

	const apiUrl = `/api/sensus/?searchQuery=${searchString}`;

	const $loader = $elementChild($module, "loader");
	loader = new Loader($loader);

	showSpinner();

	fetch(apiUrl)
		.then((response) => response.json())
		.then((res) => {
			if (res.length) {
				const $documentUl = document.createElement("ul");
				res.forEach((item) => {
					const documentItem = new DamDocumentItem(item);
					$documentUl.appendChild(documentItem.generateLiMarkup());
				});
				$module.appendChild($documentUl);
			} else {
				$module.appendChild(textNode);
			}
		})
		.catch((error) => {
			throw new Error(`api fetch error, response: ${error}`);
		})
		.finally(() => {
			hideSpinner();
		});
}

function hideSpinner() {
	loader.hide();
}

function showSpinner() {
	loader.show();
}

export default {
	view: "damDocuments",
	init,
};
